import {
  MemberProfileLocationTable,
  MemberProfileMap
} from '@bo-components/members/memberProfile';
import { MemberProfileMapContext } from '@bo-hooks/members/useMemberProfileMapContext';
import { useMemberProfileMap } from '@bo-hooks/members/useMemberProfileMap';

export interface MemberProfileLocationProps {
  memberId: string;
}

export const MemberProfileLocation = ({
  memberId
}: MemberProfileLocationProps) => {
  const mapContext = useMemberProfileMap({ memberId });

  return (
    <MemberProfileMapContext.Provider value={mapContext}>
      <div className="flex flex-col gap-4">
        <MemberProfileMap />
        <MemberProfileLocationTable />
      </div>
    </MemberProfileMapContext.Provider>
  );
};
